"use client"; 
// Grid of the Category apps

import { useState } from 'react'

import AppLogo from '../apps/logo'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline'

import { 
  CATEGORY_APPS_SHOW_MAX_INITIAL, 
  CATEGORY_APPS_LOAD_MORE_CHUNK 
} from '../../../lib/build-constants'
import { appShortDescription } from '../../../lib/helpers'


export default function CategoryApps({ category={} }) {

  if (!category?.parent?.id) return <></>  // If category is parent then return empty 

  const { app_categories: appCategories } = category

  const [page, setPage] = useState(1)  // Using to load more apps
  const appsVisibleCount = (page == 1) ? CATEGORY_APPS_SHOW_MAX_INITIAL : CATEGORY_APPS_SHOW_MAX_INITIAL + (page-1)*CATEGORY_APPS_LOAD_MORE_CHUNK
  const appCategoriesVisible = appCategories?.slice(0, appsVisibleCount)  // we use appCategories not apps because we need id of appCategories for voting. 
  const showMore = true 
  const appCardClass = `min-h-full relative flex items-center px-3 py-3 space-x-3 rounded 
                        bg-white  border border-gray-200 hover:border-crisp-600/50`   


  return <>
    <div id="apps_list"  className="grid md:grid-cols-1 gap-4">
      
      {appCategoriesVisible?.map((item, index) => (
        
        <div key={item?.app?.id} className={appCardClass}>               
          
          <div className="">
            <div className="text-center w-5 lg:w-8">                                    
              <span className="text-lg font-extrabold text-crisp-600 text-center	">
                {index+1}
              </span>
            </div>                
          </div>

          <div className="flex-shrink-0">
            <div className="p-1 border border-gray-200 hover:bg-gray-200 rounded-md">
              <a
                href={`/${item?.app?.slug}`}
                className="focus:outline-none ">

                <AppLogo 
                  app={item?.app} 
                  className='h-12 w-12  rounded-md text-3xl text-white'
                />

              </a>                  
            </div>
          </div>

          <div className="flex-1 min-w-0">
            <a
              href={`/${item?.app?.slug}`}
              className="focus:outline-none ">

              <h3 className="inline-flex text-lg font-medium text-gray-900 hover:text-crisp-800 hover:underline">
                <span>
                  {item?.app?.name} 
                </span>
                {item?.app?.is_opensource && (
                  <span className="ml-2 inline-flex items-center px-1.5 py-0.5 rounded-md text-sm font-medium bg-blue-100 text-blue-800">
                    opensource
                  </span>
                )}                    
              </h3>

            </a>
            <p className="text-base text-gray-500 overflow-ellipsis line-clamp-2">
              {appShortDescription(item?.app)}
            </p>    
                      
          </div>

          {/* VOTE BLOCK  */}
          {false && (
            <div className="flex-0 w-8">
              <div className=" text-center">
                
                <button
                  type="button"
                  className="w-full text-gray-600  hover:text-crisp-600 bg-white hover:bg-crisp-200 rounded-sm"
                >                      
                  <ChevronUpIcon className="mx-auto  h-6 w-6" aria-hidden="true" />
                </button>                   
                
                <button
                  type="button"
                  className="w-full text-gray-600  hover:text-crisp-600 bg-white hover:bg-crisp-200 rounded-sm"
                >                      
                  <ChevronDownIcon className="mx-auto  h-6 w-6 " aria-hidden="true" />
                </button>

              </div>                
            </div>    
          )}          

        </div>

      ))}
    
    </div>

    {showMore && (appsVisibleCount < appCategories?.length) && (
      <div className='mx-auto py-6 text-center' >
        <button
          onClick={() => setPage(page + 1)}
          type="button"          
          className="inline-flex items-center px-10 py-2 border border-gray-300 shadow-sm text-base rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          Show more 
          {/* <span className="ml-2 inline-flex items-center px-1.5 py-0.5 rounded-full text-base font-medium  text-gray-300">
            {appCategories?.length - appsVisibleCount} left
          </span> */}
        </button>
      </div>
    )}

  </>;
}
